import {css} from "lit";
import {customScrollStyles} from "../styles/CustomScrollBar.js";
import {iconStyles} from "../styles/Icons.js";

export const selectStyles = [customScrollStyles, iconStyles, css`
	:host {
		width: 100%;
	}

	.select-wrapper {
		position: relative;
		width: 100%;
		font-family: var(--pn-font-family-base);
		font-size: 14px;
		font-weight: normal;
	}
	.select-wrapper.expanded ul {
		display: block;
	}

	.select-wrapper.expanded:not(.disabled) .select-box,
	.select-wrapper:hover:not(.disabled) .select-box,
	.select-wrapper:focus-within:not(.disabled) .select-box {
		border-color: var(--pn-select-list-border-color);
		outline: none;
	}

	.select-wrapper .select-box {
		display: flex;
		align-items: center;
		padding: 10px 15px;
		margin: 0;
		height: 40px;
		width: inherit;
		border: 1px solid transparent;
		border-radius: 6px;
		background-color: transparent;
		font-family: var(--pn-font-family-base);
		text-align: inherit;
		cursor: pointer;
	}
	.select-wrapper .select-box .select-box-content {
		width: 100%;
		margin-right: 10px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.select-wrapper .select-box .select-box-content .warning {
		color: var(--pn-color-error);
		font-size: 11px;
		line-height: 22px;
		font-weight: 700;
		margin-left: 20px;
	}
	.select-wrapper .select-box .select-chevron-icon {
		display: block;
		margin-left: auto;
		height: 12px;
		width: 12px;
	}

	.select-wrapper .select-box:disabled {
		background-color: var(--pn-color-medium-dark-rock);
		cursor: default;
	}

	.select-wrapper ul {
		display: none;
		position: absolute;
		z-index: 50;
		width: inherit;
		max-height: 60vh;
		margin: 0;
		margin-top: -5px;
		padding: 5px 0;
		list-style: none;
		background-color: var(--pn-select-list-bg-color);
		box-shadow: 0 0 7px 0 rgba(0,0,0,.2);
		border: none;
		border-radius: 4px;
		overflow-x: hidden;
		overflow-y: auto;
		font: inherit;
		cursor: default;
	}

	.select-wrapper ul li {
		padding: 10px 11px;
		background-color: var(--pn-select-list-bg-color);
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.select-wrapper ul li .warning {
		color: var(--pn-color-error);
		font-size: 11px;
		line-height: 22px;
		font-weight: 700;
		margin-left: 20px;
	}
	.select-wrapper ul li:not(:first-child) {
		border-top: none;
	}
	.select-wrapper ul li.active {
		background-color: var(--pn-select-option-bg-color-hover);

		/* Indiciate that the item is active without only using color (see WCAG 1.4.1) */
		text-decoration: underline;
	}
	.select-wrapper ul li.selected {
		font-weight: bold;
	}

	.select-wrapper.solid-border .select-box {
		border: 1px solid var(--pn-input-border-color);
	}
	.select-wrapper.solid-border.expanded:not(.disabled) .select-box,
	.select-wrapper.solid-border:hover:not(.disabled) .select-box,
	.select-wrapper.solid-border:focus-within:not(.disabled) .select-box {
		border: 1px solid var(--pn-input-border-color-focus);
	}

	/* In a form with other inputs and/or textareas */
	.select-wrapper.solid-border-light .select-box {
		border: 1px solid var(--pn-input-border-color);
	}
	.select-wrapper.solid-border-light.expanded:not(.disabled) .select-box,
	.select-wrapper.solid-border-light:hover:not(.disabled) .select-box,
	.select-wrapper.solid-border-light:focus-within:not(.disabled) .select-box {
		border: 1px solid var(--pn-input-border-color-focus);
	}

	/* Styles for specific elements */
	#project-select--wrapper .select-box {
		font-size: 18px;
	}
`];
